import { Typography } from 'antd';
import { RichText } from 'prismic-reactjs';
import React from 'react';
import { TermContentWrapper } from './style';

interface TermProps {
  data: any;
}
const { Title, Paragraph } = Typography;

const TermContent: FC<TermProps> = ({ data }) => (
  <TermContentWrapper className="wrapper">
    <Typography>
      <Title id="terms-and-conditions">{RichText.render(data?.title?.raw)}</Title>
      {data?.content?.raw?.map((item) => (
        <Paragraph id={`${item?.text === 'PRIVACY POLICY' ? 'privacy-policy': ''}`}>{RichText.render([item])}</Paragraph>
      ))}
    </Typography>
  </TermContentWrapper>
);

export default TermContent;
